import { render, staticRenderFns } from "./BIM.vue?vue&type=template&id=10b69a4e&scoped=true"
import script from "./BIM.vue?vue&type=script&lang=js"
export * from "./BIM.vue?vue&type=script&lang=js"
import style0 from "./BIM.vue?vue&type=style&index=0&id=10b69a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b69a4e",
  null
  
)

export default component.exports